// Mutations enums
export enum MutationTypes {
  ADD_MESSAGE = "ADD_MESSAGE",
  HIDE_MESSAGE = "HIDE_MESSAGE",
}
